import React, { useCallback, useState } from 'react';

import { useSnackbar } from 'notistack';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router';

import { Box, Container } from '@mui/material';

import PageHeader from '~/components/Common/Elements/PageHeader';

import { formatUTCDateDateTimeWidget } from '~/services/TimeService';
import { createTourDeal } from '~/services/ToursService';

import TourDealPageForm from './components/TourDealPageForm';
import { TourDealPageBody } from './types';

function DealPageCreate() {
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();
  const [fetching, setFetching] = useState(false);

  const handleSubmit = useCallback(
    async (formValues: TourDealPageBody) => {
      setFetching(true);

      try {
        await createTourDeal({
          ...formValues,
          startAt: formatUTCDateDateTimeWidget(new Date(formValues.startAt)),
          endAt: formatUTCDateDateTimeWidget(new Date(formValues.endAt)),
        });
        enqueueSnackbar('Deal page created successfully', { variant: 'success' });
        history.push('/tours/deals');
      } catch (error) {
        enqueueSnackbar(`Error saving deal page: ${error}`, { variant: 'error' });
      } finally {
        setFetching(false);
      }
    },
    [enqueueSnackbar, history],
  );

  return (
    <Container maxWidth="xl">
      <Helmet>
        <title>Create New Tour Deal Page</title>
      </Helmet>

      <PageHeader title="Create Tour Deal Page" backButton="/tours/deals" />

      <Box mt={1}>
        <TourDealPageForm onSubmit={handleSubmit} isFetching={fetching} />
      </Box>
    </Container>
  );
}

export default DealPageCreate;
